// extracted by mini-css-extract-plugin
export default {"form__item":"Input_form__item__sUk+8","label":"Input_label__NXpCD","input":"Input_input__E5rzA","showBtn":"Input_showBtn__Nf7iw"};